export default "__VITE_ASSET__D5zt0_PO__"